import React from "react";
import { createContext, useContext, ReactNode, useState } from "react";
import ErrorPopupComponent from "../component/atoms/PopupErrorComponent";

type PopupContextValue = {
  showPopup: (message: string, isRedirect: boolean, isExpired?: boolean) => void;
};

export const PopupContext = createContext<PopupContextValue>({
  showPopup: () => {},
});

export function PopupProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [isRedirect, setIsRedirect] = useState(false);
  const [isExpired, setIsExpired] = useState(false);

  function showPopup(message: string, isRedirect: boolean = false, isExpired?: boolean) {
    setMessage(message);
    setIsRedirect(isRedirect ? isRedirect : false);
    setIsExpired(isExpired ? isExpired : false);
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <PopupContext.Provider value={{ showPopup }}>
      {children}
      <ErrorPopupComponent
        display={open}
        onChangeDisplay={handleClose}
        errorMessage={message}
        isRedirect={isRedirect}
        isExpired={isExpired}
      />
    </PopupContext.Provider>
  );
}

export function usePopup() {
  const { showPopup } = useContext(PopupContext);
  return { showPopup };
}
